var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheck2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_check2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2117",
    d: "M4.02893 9.37565C4.06126 9.66664 4.70694 10.1318 4.92528 10.3033C5.44615 10.7126 5.87218 11.3255 6.34189 11.7952C6.87704 12.3303 7.39102 12.9473 7.81178 13.5785C8.10159 14.0132 8.26954 13.5765 8.53576 13.2807C8.86714 12.9125 9.23245 12.4696 9.62016 12.165C10.2919 11.6372 10.8135 10.9062 11.4505 10.3472C11.8437 10.0021 12.183 9.60162 12.5913 9.26282C13.0346 8.89499 13.4056 8.4449 13.801 8.03426C14.2415 7.5769 14.6551 7.08444 15.0986 6.62391C15.2334 6.48387 15.3731 6.24411 15.5373 6.14753C15.7251 6.03708 15.795 5.74915 15.9886 5.65234",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck2);
export default __webpack_public_path__ + "static/media/icon-check2.aa8a714f91d5e0e01586701687c408e9.svg";
export { ForwardRef as ReactComponent };